const styles = theme => ({
  chipAvatar: {
    height: 28,
    width: 28,
    cursor: "pointer",
  },
})

export default styles
